import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import toast from 'react-hot-toast';

export default function Login() {
  const [form, setForm] = useState({ login: '', senha: '' });
  const [verSenha, setVerSenha] = useState(false);
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(form.login, form.senha);
      navigate(u?.perfil === 'superadmin' ? '/admin/oficinas' : '/');
    } catch (err) {
      toast.error(err.response?.data?.erro || 'Login ou senha incorretos');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-blue-700 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl p-8 w-full max-w-sm">
        <div className="text-center mb-8">
          <img src="/logo-torqueapp.png" alt="TorqueApp — Gestão para Oficinas" className="w-52 mx-auto mb-3" />
          <p className="text-gray-500 text-sm">Faça login para continuar</p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">E-mail ou Telefone</label>
            <input
              type="text"
              required
              className="w-full border border-gray-300 rounded-lg px-3 py-3 text-base focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={form.login}
              onChange={e => setForm(f => ({ ...f, login: e.target.value }))}
              placeholder="seu@email.com ou (00) 00000-0000"
              autoComplete="username"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Senha</label>
            <div className="relative">
              <input
                type={verSenha ? 'text' : 'password'}
                required
                className="w-full border border-gray-300 rounded-lg px-3 py-3 pr-10 text-base focus:outline-none focus:ring-2 focus:ring-blue-500"
                value={form.senha}
                onChange={e => setForm(f => ({ ...f, senha: e.target.value }))}
                placeholder="••••••••"
              />
              <button type="button" tabIndex={-1}
                onClick={() => setVerSenha(v => !v)}
                className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-700 text-lg px-1">
                {verSenha ? '🙈' : '👁️'}
              </button>
            </div>
          </div>
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-blue-600 text-white py-3 rounded-lg font-semibold text-base hover:bg-blue-700 transition-colors disabled:opacity-50 mt-2"
          >
            {loading ? 'Entrando...' : 'Entrar'}
          </button>
          <button
            type="button"
            onClick={() => navigate('/recuperar-senha')}
            className="w-full text-blue-600 text-sm hover:underline mt-1"
          >
            Esqueci minha senha
          </button>
        </form>
      </div>
    </div>
  );
}
